<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page013">
<div class="jstfy" id="page013_1">BASICS</div>
<div class="jstfy" id="page013_2"><a href="#/page_014">Baguette   <span class="page013_2a">page 14</span></a></div>
<div class="jstfy" id="page013_3"><a href="#/page_016">Brioches   <span class="page013_3a">page 16</span></a></div>
<div class="jstfy" id="page013_4"><a href="#/page_018">Apricot croissants   <span class="page013_4a">page 18</span></a></div>
<div class="jstfy" id="page013_5"><a href="#/page_020">Aïoli   <span class="page013_5a">page 20</span></a></div>
<div class="jstfy" id="page013_6"><a href="#/page_022">Vegetable stock   <span class="page013_6a">page 22</span></a></div>
<div class="jstfy" id="page013_7"><a href="#/page_024">Olive paste   <span class="page013_7a">page 24</span></a></div>
<div class="jstfy" id="page013_8"><a href="#/page_026">Provençal pesto   <span class="page013_8a">page 26</span></a></div>
<div class="jstfy" id="page013_9"><a href="#/page_026">Vinaigrette   <span class="page013_9a">page 26</span></a></div>
<div class="jstfy" id="page013_10"><a href="#/page_028">Fromage frais   <span class="page013_10a">page 28</span></a></div>
<div class="jstfy" id="page013_11"><span href="#/page_030" title="Link target outside of Sample">Béchamel sauce   <span class="page013_11a">page 30</span></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_013.vue?4cb5e68c